import logo from "@/assets/app-logo.svg";

export default function PulseLoader() {
  return (
    <img src={logo} alt="Pulse Logo" className="w-20 h-20 logo-pulse-fast" />
  );
}
